import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

// Cross-tenant admin data — not scoped to companies/:companyId; enforced server-side by AdminPanelGuard.
export const useDeleteTeamMember = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: deleteMember, isPending } = useAppMutation([QueryKey.DELETE_TEAM_MEMBER], {
    mutationFn: ({ id }: { id: string }) =>
      ApiService.delete<{ id: string }, undefined>({
        endpoint: BackendRoute.TEAM_MEMBERS,
        routePath: [id],
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_TEAM_MEMBERS] }),
  });

  return { deleteMember, isPending };
};
